import NeverIcon from './NeverIcon';

export default NeverIcon;
